import { setGlobalTestRuntime } from "allure-js-commons/sdk/runtime";
/* eslint no-underscore-dangle: "off" */
import { afterEach, beforeAll, beforeEach } from "vitest";
import { commands } from "vitest/browser";

import { allureVitestLegacyApi } from "../legacy.js";
import { registerAllureVitestExpect } from "../matchers.js";
import { VitestBrowserTestRuntime } from "../VitestBrowserTestRuntime.js";

registerAllureVitestExpect();

beforeAll(() => {
  setGlobalTestRuntime(new VitestBrowserTestRuntime());
});

beforeEach(async ({ skip, task }) => {
  (task as any).meta = {
    ...task.meta,
    // @ts-expect-error
    vitestWorker: globalThis?.__vitest_worker__?.ctx?.workerId,
    browser: task.file.projectName,
  };

  const inTestPlan = (await commands?.existsInTestPlan?.(task)) ?? true;

  if (!inTestPlan) {
    task.meta.allureSkip = true;
    skip();
    return;
  }

  globalThis.allure = allureVitestLegacyApi;
});

afterEach(() => {
  // @ts-expect-error
  globalThis.allure = undefined;
});
